import { GripVertical } from 'lucide-react';
import { PanelGroup, Panel, PanelResizeHandle } from 'react-resizable-panels';
import ChatConversationHistoryView from '../ChatConversationHistoryView.jsx';
import { ASSISTANT_SPLIT_RESIZE_HANDLE_CLASS } from './assistantLayoutConstants.js';

/**
 * Historial vs split documento+pantalla vs solo documento vs solo chat.
 */
export function AssistantMainContent({
  historyOpen,
  historyViewProps,
  isDocumentPanelOpen,
  isFullscreen,
  chatBody,
  documentPanelNode,
}) {
  if (historyOpen) {
    return <ChatConversationHistoryView {...historyViewProps} />;
  }

  if (isDocumentPanelOpen && isFullscreen) {
    return (
      <PanelGroup
        direction="horizontal"
        className="flex h-full min-h-0 w-full flex-1"
        autoSaveId="aimsos-chat-assistant-document-split"
      >
        <Panel defaultSize={42} minSize={28} className="min-h-0 min-w-0">
          <div className="flex h-full min-h-0 flex-col overflow-hidden pr-2">{chatBody}</div>
        </Panel>
        <PanelResizeHandle className={ASSISTANT_SPLIT_RESIZE_HANDLE_CLASS}>
          <div className="absolute inset-y-0 left-1/2 flex -translate-x-1/2 items-center justify-center">
            <div
              className={[
                'rounded-full bg-surface-muted p-1 opacity-0 transition-opacity',
                'group-hover:opacity-100 group-data-[resize-handle-active]:opacity-100',
              ].join(' ')}
            >
              <GripVertical className="size-3 text-content-secondary" aria-hidden />
            </div>
          </div>
        </PanelResizeHandle>
        <Panel defaultSize={58} minSize={32} className="min-h-0 min-w-0">
          <div className="flex h-full min-h-0 flex-col overflow-hidden pl-1">{documentPanelNode}</div>
        </Panel>
      </PanelGroup>
    );
  }

  if (isDocumentPanelOpen) {
    return documentPanelNode;
  }

  return chatBody;
}
